export const AUTH_STEP_TYPE = {
  EMAIL: 'email',
  PASSWORD: 'password',
  RECOVERY: 'recovery',
  RECOVERY_SENT: 'recovery-sent',
  SIGNUP_EMAIL_SENT: 'signup-email-sent',
  SIGNUP_OTP: 'signup-otp',
  RATE_LIMITED: 'rate-limited',
  PAGE_ROUTE: 'page-route',
  GOOGLE_ONLY: 'google-only',
  ENTITY_NOTICE_ENTRY: 'entity-notice-entry',
  ENTITY_NOTICE_OTP: 'entity-notice-otp',
  ENTITY_NOTICE_COMPLETE_DATA: 'entity-notice-complete-data',
  ENTITY_NOTICE_FINALIZE: 'entity-notice-finalize',
  ENTITY_NOTICE_TERMINAL: 'entity-notice-terminal',
} as const

export const AUTH_STEP_PATHNAME = {
  EMAIL: '/login',
  PASSWORD: '/login/details',
  RECOVERY: '/recuperar-senha',
  SIGNUP_EMAIL_SENT: '/cadastro/confirmacao-por-email-enviada',
  SIGNUP_OTP: '/cadastro/confirmacao-por-codigo',
  RATE_LIMITED: '/cadastro/erro-de-limite-de-tentativas',
  GOOGLE_ONLY: '/login/google',
  ENTITY_NOTICE_ENTRY: '/login',
} as const

export type AuthStep =
  | { type: typeof AUTH_STEP_TYPE.EMAIL }
  | { type: typeof AUTH_STEP_TYPE.PASSWORD; email: string }
  | { type: typeof AUTH_STEP_TYPE.RECOVERY; email?: string }
  | { type: typeof AUTH_STEP_TYPE.RECOVERY_SENT }
  | { type: typeof AUTH_STEP_TYPE.SIGNUP_EMAIL_SENT; email: string }
  | { type: typeof AUTH_STEP_TYPE.SIGNUP_OTP; email: string }
  | { type: typeof AUTH_STEP_TYPE.RATE_LIMITED }
  | { type: typeof AUTH_STEP_TYPE.PAGE_ROUTE; pathname: string; query?: Record<string, string> }
  | { type: typeof AUTH_STEP_TYPE.GOOGLE_ONLY; email: string }
  | { type: typeof AUTH_STEP_TYPE.ENTITY_NOTICE_ENTRY }
  | { type: typeof AUTH_STEP_TYPE.ENTITY_NOTICE_OTP; email: string }
  | { type: typeof AUTH_STEP_TYPE.ENTITY_NOTICE_COMPLETE_DATA; email: string; token: string }
  | { type: typeof AUTH_STEP_TYPE.ENTITY_NOTICE_FINALIZE; email: string; token: string }
  | { type: typeof AUTH_STEP_TYPE.ENTITY_NOTICE_TERMINAL; email: string }

export function stepToUrl(step: AuthStep): { pathname: string; query?: Record<string, string> } {
  switch (step.type) {
    case AUTH_STEP_TYPE.EMAIL:
      return { pathname: AUTH_STEP_PATHNAME.EMAIL }
    case AUTH_STEP_TYPE.PASSWORD:
      return { pathname: AUTH_STEP_PATHNAME.PASSWORD, query: { email: step.email } }
    case AUTH_STEP_TYPE.RECOVERY:
      return {
        pathname: AUTH_STEP_PATHNAME.RECOVERY,
        ...(step.email && { query: { email: step.email } }),
      }
    case AUTH_STEP_TYPE.RECOVERY_SENT:
      return { pathname: AUTH_STEP_PATHNAME.RECOVERY, query: { sent: 'true' } }
    case AUTH_STEP_TYPE.SIGNUP_EMAIL_SENT:
      return { pathname: AUTH_STEP_PATHNAME.SIGNUP_EMAIL_SENT, query: { email: step.email } }
    case AUTH_STEP_TYPE.SIGNUP_OTP:
      return { pathname: AUTH_STEP_PATHNAME.SIGNUP_OTP, query: { email: step.email } }
    case AUTH_STEP_TYPE.RATE_LIMITED:
      return { pathname: AUTH_STEP_PATHNAME.RATE_LIMITED }
    case AUTH_STEP_TYPE.PAGE_ROUTE:
      return { pathname: step.pathname, query: step.query }
    case AUTH_STEP_TYPE.GOOGLE_ONLY:
      return { pathname: AUTH_STEP_PATHNAME.GOOGLE_ONLY, query: { email: step.email } }
    case AUTH_STEP_TYPE.ENTITY_NOTICE_ENTRY:
    case AUTH_STEP_TYPE.ENTITY_NOTICE_OTP:
    case AUTH_STEP_TYPE.ENTITY_NOTICE_COMPLETE_DATA:
    case AUTH_STEP_TYPE.ENTITY_NOTICE_FINALIZE:
    case AUTH_STEP_TYPE.ENTITY_NOTICE_TERMINAL:
      // The entity-notice fake-door flow never leaves the iframe's own
      // /login?usage=iframe URL — every step past the entry screen is
      // in-memory only (R2), so they all collapse to the same pathname.
      return { pathname: AUTH_STEP_PATHNAME.ENTITY_NOTICE_ENTRY }
  }
}
